import React, { useState, useEffect } from 'react';
import { getSocialLinks } from '../services/api';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube, FaTelegramPlane, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import { BsLink45Deg } from 'react-icons/bs'; // For 'Other'

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await getSocialLinks();
        setSocialLinks(response.data);
      } catch (error) {
        console.error('Error fetching social links for footer:', error);
      }
    };
    fetchLinks();
  }, []);

  return (
    <footer className="relative h-48 flex flex-col items-center justify-center text-white overflow-hidden mt-10 p-4">
      <img
        src="https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=2000&auto=format&fit=crop"
        alt="Tall apartment buildings landscape"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <div className="relative z-10 text-center flex flex-col items-center">
        {socialLinks.length > 0 && (
          <div className="flex space-x-4 mb-4">
            {socialLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-zinc-300 transition-colors duration-200 text-2xl"
                aria-label={link.platform}
              >
                {link.platform === 'Facebook' && <FaFacebookF />}
                {link.platform === 'Twitter' && <FaTwitter />}
                {link.platform === 'Instagram' && <FaInstagram />}
                {link.platform === 'LinkedIn' && <FaLinkedinIn />}
                {link.platform === 'YouTube' && <FaYoutube />}
                {link.platform === 'Telegram' && <FaTelegramPlane />}
                {link.platform === 'TikTok' && <FaTiktok />}
                {link.platform === 'WhatsApp' && <FaWhatsapp />}
                {link.platform === 'Other' && <BsLink45Deg />}
              </a>
            ))}
          </div>
        )}
        <p className="text-lg font-semibold tracking-wider text-emerald-400">Emerald Homes</p>
        
        <p className="text-sm text-zinc-300">
          Copyright 2025
        </p>
      </div>
    </footer>
  );
};

export default Footer;
